<mat-accordion *ngIf="!isLoading">
    <mat-expansion-panel *ngFor="let partitioning of filteredList"
        [expanded]="containSelectedCode(partitioning.simulations)"
        [disabled]="!partitioning.simulations.length">
        <mat-expansion-panel-header>
            <mat-panel-title [ngClass]="{selected: containSelectedCode(partitioning.simulations)}">
                {{ partitioning.text.shortLabel }}
            </mat-panel-title>
            <mat-panel-description>
                <span>{{ partitioning.simulations.length }}</span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <app-simulations-list
            [simulationsList]="partitioning.simulations"
            [partitioningCode]="partitioning.code"
            [isActionAllowed]="visibility === visibilityType.perso"
            [isAuthorShown]="visibility === visibilityType.shared"
            [isCreatedAtShown]="!isMJP || visibility !== visibilityType.template"
            [selectedCode]="selectedCode"></app-simulations-list>
    </mat-expansion-panel>
</mat-accordion>

<mat-progress-bar
    *ngIf="!partitioningsList || isLoading"
    class="progress-bar"
    color="accent"
    mode="indeterminate">
</mat-progress-bar>
